import { createJSONStorage } from 'jotai/utils';

/** Pass this as the third param to atomWithStorage() to use session storage instead of local storage */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const jotaiSessionStorage = createJSONStorage<any>(() =>
  typeof window !== 'undefined' ? window.sessionStorage : (undefined as unknown as Storage)
);
